const origin='https://uogorod.ru';
const validId=value=>/^[1-9]\d*$/.test(String(value));
const uuid=value=>/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(String(value));

// Describe only the comments actually reachable in the displayed thread.
// Comment is semantic markup, not a standalone Google review/rating feature.
export function commentSchema({path,parent,comments=[],photos={},publicContext=false}){
 if(!publicContext||typeof path!=='string'||!path.startsWith('/')||path.startsWith('//'))return null;
 const page=new URL(path,origin);if(page.origin!==origin)return null;
 page.hash='';page.search='';const url=page.href;
 const byParent=new Map(),seen=new Set(),nodes=[];
 for(const c of comments){
  if(!validId(c.id)||c.deleted)continue;
  const key=c.parent_id==null?'root':String(c.parent_id);
  if(!byParent.has(key))byParent.set(key,[]);byParent.get(key).push(c);
 }
 const pending=[...(byParent.get('root')||[])].reverse();
 while(pending.length){
  const c=pending.pop(),key=String(c.id);if(seen.has(key))continue;seen.add(key);
  const node={'@type':'Comment','@id':url+'#comment-'+key,url:url+'#comment-'+key};
  if(String(c.text||'').trim())node.text=String(c.text);
  const author=c.author,nickname=String(author?.nickname||'').trim(),name=nickname&&nickname!=='[DELETED]'?'@'+nickname:String(author?.name||'').trim();
  if(name&&name!=='[DELETED]'){node.author={'@type':'Person',name};if(validId(author?.id))node.author.url=origin+'/profiles/'+author.id;}
  const time=Date.parse(c.created_at);if(Number.isFinite(time))node.datePublished=new Date(time).toISOString();
  const image=[...new Set((photos[key]||[]).filter(p=>uuid(p.uuid)).map(p=>origin+'/api/comments/media/'+p.uuid+'?comment='+key))];
  if(image.length)node.image=image;
  if(c.parent_id!=null)node.parentItem={'@id':url+'#comment-'+c.parent_id};
  else if(typeof parent==='string'&&parent.startsWith(origin+'/'))node.parentItem={'@id':parent};
  // Google's Comment feature requires a real author and publication date.
  // Keep the visible content; omit incomplete metadata instead of inventing it.
  if((node.text||image.length)&&node.author&&node.datePublished)nodes.push(node);
  pending.push(...[...(byParent.get(key)||[])].reverse());
 }
 return nodes.length?{'@context':'https://schema.org','@graph':nodes}:null;
}
